class TdsBfClock extends HTMLElement {
  connectedCallback() {
    clearInterval(this.timer);
    this.end = Date.parse(this.dataset.end);
    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }
  disconnectedCallback() { clearInterval(this.timer); }
  tick() {
    const digits = this.querySelector('[data-clock]');
    const ended = this.querySelector('[data-ended]');
    if (!digits || !ended) return;
    if (!Number.isFinite(this.end)) { digits.hidden = true; return; }
    const n = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
    digits.hidden = n === 0;
    ended.hidden = n > 0;
    const values = {days:Math.floor(n/86400), hours:Math.floor(n/3600)%24, minutes:Math.floor(n/60)%60, seconds:n%60};
    for (const [key,value] of Object.entries(values)) {
      const el = this.querySelector('[data-' + key + ']');
      const text = String(value).padStart(2,'0');
      if (el && el.textContent !== text) el.textContent = text;
    }
  }
}
if (!customElements.get('tds-bf-clock')) customElements.define('tds-bf-clock', TdsBfClock);
(() => {
  const init = () => {
    const root = document.querySelector('.st_pi-details');
    const note = root?.querySelector('[data-bf-price-note]');
    const saving = root?.querySelector('[data-bf-saving]');
    const price = root?.querySelector('[data-st-price]');
    const compare = root?.querySelector('[data-st-compare]');
    const bar = root?.querySelector('[data-bf-buybar]');
    const atc = root?.querySelector('[data-st-atc]');
    const mobilePrice = bar?.querySelector('[data-bf-mobile-price]');
    const amount = el => Number((el?.textContent || '').replace(/[^0-9.]/g, ''));
    const syncPrice = () => {
      if (mobilePrice && price && mobilePrice.textContent !== price.textContent) mobilePrice.textContent = price.textContent;
      if (!saving || !note || !price || !compare) return;
      const a=amount(price), b=amount(compare);
      const valid=Number.isFinite(a) && Number.isFinite(b) && b>a && a>0;
      note.hidden=!valid;
      if (!valid) return;
      const money=new Intl.NumberFormat('en-GB',{style:'currency',currency:saving.dataset.currency || 'GBP'}).format(b-a);
      const text=saving.dataset.prefix+' '+money;
      if (saving.textContent !== text) saving.textContent=text;
    };
    if (price && compare) {
      const observer=new MutationObserver(syncPrice);
      observer.observe(price,{childList:true,subtree:true,characterData:true});
      observer.observe(compare,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['style']});
      syncPrice();
    }
    if (bar && atc) {
      document.body.append(bar);
      document.body.classList.add('bf-has-buybar');
      let atcVisible=false;
      const media=matchMedia('(max-width:749px)');
      const syncBar=() => { bar.hidden=!media.matches || atcVisible; };
      new IntersectionObserver(entries => { atcVisible=entries[0].isIntersecting; syncBar(); }).observe(atc);
      media.addEventListener('change',syncBar);
      bar.querySelector('[data-bf-choose]').addEventListener('click',() => {
        const select=root.querySelector('select[aria-label="Choose size"]');
        const destination=select?.closest('fieldset') || root.querySelector('[data-st-option-input]')?.closest('fieldset') || atc;
        destination.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'center'});
        if (select) select.focus({preventScroll:true});
      });
      syncBar();
    }
    const mountDrawer=() => {
      const drawer=document.querySelector('.sd-drawer');
      if (!drawer) return false;
      const template=document.querySelector('#tds-bf-cart-template');
      let queued=false;
      const sync=() => {
        queued=false;
        if (template && !drawer.querySelector('.tds-bf-cart-note')) drawer.querySelector('.sd-drawer__header,.sd-header,.sd-drawer-header,.sd-cart-header')?.after(template.content.cloneNode(true));
        const empty=drawer.querySelector('.sd-empty-state');
        const match=drawer.querySelector('#sd-cart-title,.sd-cart-title')?.textContent.match(/\((\d+)\)/);
        const count=empty?0:match?Number(match[1]):null;
        if (count===null) return;
        document.querySelectorAll('.shopify-section--header cart-count').forEach(el => { if (el.textContent!==String(count)) el.textContent=String(count); });
        document.querySelectorAll('.shopify-section--header cart-dot').forEach(el => el.classList.toggle('is-visible',count>0));
      };
      new MutationObserver(() => { if (!queued) { queued=true; requestAnimationFrame(sync); } }).observe(drawer,{childList:true,subtree:true,characterData:true});
      sync();
      return true;
    };
    if (!mountDrawer()) {
      const pending=new MutationObserver(() => { if (mountDrawer()) pending.disconnect(); });
      pending.observe(document.body,{childList:true,subtree:true});
    }
  };
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init,{once:true}):init();
})();

/* Keep draft navigation explicit when another tab changes the shared preview cookie. */
(()=>{const theme='209581113669';const update=a=>{if(!document.querySelector('iframe#PBarNextFrame')&&new URLSearchParams(location.search).get('preview_theme_id')!==theme)return;const raw=a.getAttribute('href');if(!raw||raw.startsWith('#')||a.hasAttribute('download'))return;let u;try{u=new URL(raw,location.href)}catch{return}const parts=u.pathname.split('/').filter(Boolean);if(parts[0]==='en-uk')parts.shift();if(u.origin!==location.origin||(parts.length&&!['products','collections','pages','search'].includes(parts[0])))return;if(u.searchParams.get('preview_theme_id')===theme)return;u.searchParams.set('preview_theme_id',theme);a.setAttribute('href',u.pathname+u.search+u.hash)};const scan=()=>document.querySelectorAll('a[href]').forEach(update);const start=()=>{scan();let pending=false;new MutationObserver(()=>{if(!pending){pending=true;requestAnimationFrame(()=>{pending=false;scan()})}}).observe(document.body,{childList:true,subtree:true});document.addEventListener('click',e=>{const a=e.target.closest?.('a[href]');if(a)update(a)},true)};document.readyState==='loading'?document.addEventListener('DOMContentLoaded',start,{once:true}):start()})();
